module.exports = function (fox) {
    const COMMUNITY_NICK_LABEL = '_cnick_';
    const COMMUNITY_NICK_SAVE_EVENT = 'community_nick_saved';

    fox.registerWidget('Admin_CommunityService', {
        _save: function (value) {
            const api = this.getApi('saveApi', {
                method: 'client.saveNick',
                httpMethod: 'post'
            });

            return api.psend({communityName: value}).then(() => {
                this.dispatchEvent(COMMUNITY_NICK_SAVE_EVENT, value);
            });
        },

        getNick: function () {
            return fox.utils.localStorage('getItem', COMMUNITY_NICK_LABEL) ||
                this._wom.getRoot().getOption('clientNick.communityName');
        },

        clearNick: function () {
            return this._save('').then(() => {
                this._wom.getRoot().removeOption('clientNick.communityName');
                fox.utils.localStorage('removeItem', COMMUNITY_NICK_LABEL);

                return true;
            });
        },

        setNick: function (name) {
            return this._save(name).then(() => {
                this._wom.getRoot().setOption('clientNick.communityName', name);
                fox.utils.localStorage('setItem', COMMUNITY_NICK_LABEL, name);

                return true;
            });
        }
    }, 'Controller');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/communityService.es.js